import React, { Component, Suspense, lazy } from "react";
import { inject } from "mobx-react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import TagManager from "react-gtm-module";
import Header from "./containers/Header/Header";
import Footer from "./containers/Footer/Footer";
import ROUTES from "./routes";
import { Container } from "reactstrap";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// Lazy-loaded components
const Home = lazy(() => import("./containers/Home/Home"));
const MotorInsurance = lazy(() => import("./containers/MotorInsurance/MotorInsurance"));
const MotorProductList = lazy(() => import("./containers/MotorInsurance/MotorProductList"));
const MotorFullQuote = lazy(() => import("./containers/MotorInsurance/MotorFullQuote"));
const MotorProductDetails = lazy(() => import("./containers/MotorInsurance/MotorProductDetails"));
const HomeInsurance = lazy(() => import("./containers/HomeInsurance/HomeInsurance"));
const HomeFullQuote = lazy(() => import("./containers/HomeInsurance/HomeFullQuote"));
const HomeProductList = lazy(() => import("./containers/HomeInsurance/HomeProductList"));
const HomeProductDetails = lazy(() => import("./containers/HomeInsurance/HomeProductDetails"));
const LifeInsurance = lazy(() => import("./containers/LifeInsurance/LifeInsurance"));
const TermLife = lazy(() => import("./containers/TermLife/TermLife"));
const SmallBusiness = lazy(() => import("./containers/SmallBusiness/SmallBusiness"));
const EventsLiability = lazy(() => import("./containers/EventsLiability/EventsLiability"));
const GroupLife = lazy(() => import("./containers/GroupLife/GroupLife"));
const GroupHealth = lazy(() => import("./containers/GroupHealth/GroupHealth"));
const PrivacyPolicy = lazy(() => import("./containers/Legal/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./containers/Legal/TermsOfUse"));
const AboutUs = lazy(() => import("./containers/AboutUs/AboutUs"));
const ClaimsSupport = lazy(() => import("./containers/CustomerCare/ClaimsSupport"));
const ContactUs = lazy(() => import("./containers/CustomerCare/ContactUs"));
const Faq = lazy(() => import("./containers/CustomerCare/Faq"));
const InternalError = lazy(() => import("./containers/ErrorPages/InternalError"));
const NotFound = lazy(() => import("./containers/ErrorPages/NotFound"));
const QuoteCompleted = lazy(() => import("./components/QuoteCompleted"));
const BARPHome = lazy(() => import("./components/BARPHome/BARPHome"));
const BARPPaymentOnline = lazy(() => import("./components/BARPPaymentOnline"));

if (process.env.REACT_APP_GTM_TAG) {
  TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_TAG });
}

class App extends Component {
  componentDidMount() {
    const { contentStore } = this.props;
    contentStore.fetchGlobalBlocks();
  }

  render() {
    return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="page-container d-flex flex-column">
          <Header />
          <Suspense
            fallback={
              <Container
                fluid
                className="d-flex align-items-center justify-content-center flex-grow-1"
              >
                <h4>Loading...</h4>
              </Container>
            }
          >
            <Routes>
              <Route path={ROUTES.motorInsurance} element={<MotorInsurance />} />
              <Route path={ROUTES.motorFullQuote} element={<MotorFullQuote />} />
              <Route path={ROUTES.motorProductList} element={<MotorProductList />} />
              <Route path={ROUTES.motorProductDetails} element={<MotorProductDetails />} />
              <Route path={ROUTES.motorCompleted} element={<QuoteCompleted />} />

              <Route path={ROUTES.homeInsurance} element={<HomeInsurance />} />
              <Route path={ROUTES.homeFullQuote} element={<HomeFullQuote />} />
              <Route path={ROUTES.homeProductList} element={<HomeProductList />} />
              <Route path={ROUTES.homeProductDetails} element={<HomeProductDetails />} />
              <Route path={ROUTES.homeCompleted} element={<QuoteCompleted />} />

              <Route path={ROUTES.smallBusiness} element={<SmallBusiness />} />
              <Route path={ROUTES.eventsLiability} element={<EventsLiability />} />
              <Route path={ROUTES.groupLife} element={<GroupLife />} />
              <Route path={ROUTES.groupHealth} element={<GroupHealth />} />
              <Route path={ROUTES.lifeInsurance} element={<LifeInsurance />} />
              <Route path={ROUTES.BARPPaymentOnline} element={<BARPPaymentOnline />} />
              <Route path={ROUTES.BARPHome} element={<BARPHome />} />
              <Route path={ROUTES.termLife} element={<TermLife />} />

              <Route path={ROUTES.privacyPolicy} element={<PrivacyPolicy />} />
              <Route path={ROUTES.termsOfUse} element={<TermsOfUse />} />
              <Route path={ROUTES.aboutUs} element={<AboutUs />} />
              <Route path={ROUTES.claimsSupport} element={<ClaimsSupport />} />
              <Route path={ROUTES.contactUs} element={<ContactUs />} />
              <Route path={ROUTES.faq} element={<Faq />} />
              <Route path={ROUTES.internalError} element={<InternalError />} />
              <Route path={ROUTES.index} element={<Home />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default inject("contentStore")(App);
